import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=aa40a6c8"
import script from "./Hint.vue?vue&type=script&lang=ts"
export * from "./Hint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports